import { PersonalContentNav } from './PersonalContentNav';

export default PersonalContentNav;
